<template>
  <div class="nav-right d-flex align-items-center gap-5">
    <div
      class="mobile-menu-btn d-lg-none d-block"
      :class="{ 'show-menu': isMenuVisible }"
      @click="$emit('menu-toggle')"
    >
      <h5 class="text-white mb-0">
        <i class="bi-list"></i>
      </h5>
    </div>

    <div class="hotline d-xxl-flex d-none">
      <div class="hotline-icon">
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1225_6)">
            <path
              d="M2.88867 3.31366C1.52734 3.7121 0.451563 4.8078 0.0996094 6.15585C0.0199219 6.45468 0 6.97265 0 8.53319L0.00664063 10.5254L7.37109 16.0039C11.4352 19.0254 14.948 21.5887 15.2004 21.7215C16.3027 22.2926 17.684 22.2926 18.7996 21.7215C19.0719 21.582 22.359 19.1781 26.6289 16.0039L33.9934 10.5254L34 8.53983C34 6.3285 33.9734 6.10936 33.5551 5.28593C33.2363 4.64843 32.5391 3.95116 31.9016 3.63241C30.9453 3.15429 32.134 3.18749 16.9602 3.19413C4.13711 3.19413 3.26055 3.20741 2.88867 3.31366ZM30.5801 6.0164C31.1977 6.34843 31.2973 6.61405 31.3305 7.96874L31.357 9.06444L24.4773 14.1777C19.291 18.0359 17.5312 19.3109 17.3055 19.3773C17.0531 19.4504 16.9469 19.4504 16.7012 19.3773C16.4754 19.3109 14.6891 18.0226 9.52266 14.1777L2.64297 9.06444L2.66953 7.96874C2.68945 7.07226 2.71602 6.83319 2.81563 6.64061C3.04141 6.20897 3.31367 6.00311 3.78516 5.90351C3.91133 5.87694 9.93437 5.86366 17.166 5.8703L30.3145 5.87694L30.5801 6.0164Z"
            />
            <path
              d="M0.000124167 20.5926C0.000124167 28.1894 -0.0197977 27.7844 0.445046 28.7141C0.757155 29.3316 1.45442 30.0355 2.09192 30.3609C3.03489 30.8457 1.85286 30.8125 17.0001 30.8125C32.1275 30.8125 30.9454 30.8457 31.9017 30.3676C32.5392 30.0488 33.2365 29.3516 33.5552 28.7141C34.0267 27.7844 34.0001 28.1961 33.9868 20.5926L33.9669 13.7461L32.672 14.7023L31.3771 15.6652L31.3439 21.3961C31.3107 26.8348 31.304 27.1402 31.1845 27.3594C31.0118 27.6848 30.8857 27.8176 30.5802 27.9836L30.3146 28.123H17.0001H3.68567L3.42005 27.9836C3.11458 27.8176 2.98841 27.6848 2.81575 27.3594C2.69622 27.1402 2.68958 26.848 2.66966 21.4027L2.64973 15.6785L1.41458 14.7621C0.730593 14.2574 0.139577 13.8191 0.0864523 13.7926C0.0134054 13.7461 0.000124167 14.9082 0.000124167 20.5926Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_1225_6">
              <rect width="34" height="34" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="hotline-info">
        <h6>
          <a href="mailto:public@hiwald.com"
            ><span class="__cf_email__" data-cfemail="7d14131b123d18051c100d1118531e1210"
              >public@hiwald.com</span
            ></a
          >
        </h6>
      </div>
    </div>

    <div class="hotline d-xxl-flex d-none">
      <div class="hotline-icon">
        <svg
          t="1737626077309"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4503"
          width="34"
          height="34"
        >
          <path
            d="M217.856 94.677333c-36.608 14.762667-60.928 38.485333-96.597333 83.2-88.618667 111.232-9.386667 332.8 194.730666 535.210667l10.581334 10.368c192 184.576 434.986667 264.533333 527.701333 184.064l3.029333-2.816-1.450666 1.194667a249.301333 249.301333 0 0 0 64.042666-77.994667c33.152-64 24.149333-130.858667-41.173333-182.954667-94.037333-75.008-157.184-77.568-219.434667-20.48l-6.997333 6.570667-18.005333 17.834667c-7.808-1.621333-19.882667-7.338667-34.730667-16.896-29.610667-19.114667-66.517333-50.901333-108.586667-92.586667-41.941333-41.642667-74.069333-78.208-93.312-107.605333l-3.882666-6.101334a120.448 120.448 0 0 1-12.245334-24.832l-0.938666-3.413333 18.133333-17.92 6.613333-6.954667c57.472-61.738667 54.912-124.373333-20.650666-217.642666-51.328-63.36-109.653333-83.328-166.826667-60.245334z m99.925333 113.493334l11.221334 14.08c37.546667 48.682667 37.888 64.853333 16.384 89.258666l-8.32 8.874667-21.12 20.821333c-45.482667 45.056-25.258667 102.314667 41.856 181.205334l14.08 16.085333 15.232 16.682667 8.106666 8.533333 16.981334 17.621333 18.176 18.261334 9.258666 9.130666 18.090667 17.450667 17.408 16.298667c5.717333 5.205333 11.306667 10.24 16.810667 15.104l16.213333 13.909333c79.616 66.56 137.216 86.570667 182.698667 41.685333l21.034666-20.992 5.546667-5.248c24.277333-22.186667 39.296-25.301333 80.725333 3.968l12.586667 9.258667 14.250667 11.093333c31.232 24.917333 34.261333 47.573333 18.602666 77.781334a165.845333 165.845333 0 0 1-26.88 36.608l-7.253333 7.338666-5.546667 5.12-5.333333 4.650667c-14.421333 14.293333-69.888 15.658667-141.184-7.722667-90.709333-29.781333-189.994667-92.074667-280.746667-182.101333-177.109333-175.658667-241.408-355.413333-188.16-422.272 26.453333-33.194667 43.648-49.92 61.653334-57.173333 19.285333-7.808 38.570667-1.194667 67.626666 34.688z"
            fill="#ffffff"
            p-id="4504"
          ></path>
        </svg>
      </div>
      <div class="hotline-info">
        <h6>
          <a href="tel:0898-6530-5790"
            ><span class="__cf_email__" data-cfemail="7d14131b123d18051c100d1118531e1210"
              >0898-6530-5790</span
            ></a
          >
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactInfo",
  props: {
    isMenuVisible: Boolean,
  },
};
</script>
<style scoped>
/* 保持原有样式导入 */
@import url("../../assets/css/animate.css");
@import url("../../assets/css/all.css");
@import url("../../assets/css/bootstrap.min.css");
@import url("../../assets/css/boxicons.min.css");
@import url("../../assets/css/bootstrap-icons.css");
@import url("../../assets/css/swiper-bundle.css");
@import url("../../assets/css/nice-select.css");
@import url("../../assets/css/magnific-popup.css");
@import url("../../assets/css/style.css");
</style>



// WEBPACK FOOTER //
// src/components/components/ContactInfo.vue